import {Injectable} from '@angular/core';

/**
 * 003-retire-ngrx: minimal replacement for the store-wide reset that logout
 * should have performed. Services owning shared state register a reset
 * callback; SecurityService.logout() invokes them all so no state from a
 * previous session survives into the next login (research D6 — the old
 * logoutAction only cleared two flags, an audited bug).
 *
 * Deliberately tiny: no generics, no ordering guarantees, no unregister —
 * state-holder services are singletons with app lifetime.
 */
@Injectable({providedIn: 'root'})
export class StateResetRegistry {
  private readonly resets: Array<() => void> = [];

  register(reset: () => void): void {
    this.resets.push(reset);
  }

  resetAll(): void {
    this.resets.forEach((reset) => reset());
  }
}
